import { List } from '@kerfjs/ui/list';
import type { SafeHtml } from 'kerfjs';

import type { OrgSavingsT } from '../../../data/api.js';
import { SavingsByMonthChart } from '../savings-by-month-chart.js';

/** The By month segment: the bar chart alone, with no divider or caption (HS2-5YEH0R). */
export function SavingsByMonth({ savings }: { savings: OrgSavingsT }): SafeHtml {
  return (
    <section aria-label="Savings by Month">
      <List gap="xs" controlInsets="rl">
        <SavingsByMonthChart savings={savings} />
      </List>
    </section>
  );
}
